<template>
  <div>
    <small class="d-block mb-3">
      Top {{ filteredWords.length == 10 ? '10' : '' }} Keywords
      <b-icon-info-circle v-b-tooltip.hover="'These are the keywords we’ve determined most relevant to users. To remove a keyword, hit the “Mute” icon.'"/>
    </small>
    <b-skeleton-wrapper :loading="!page.id">
      <template #loading>
        <div v-for="i in [30,20,35]" :key="i" class="word-list-item d-flex justify-content-between align-items-center mb-1">
          <b-skeleton :width="`${i}%`" />
        </div>
      </template>
      <div v-for="word in filteredWords" :key="word.word" class="word-list-item d-flex d-flex justify-content-between align-items-center mb-1">
        <div class="item flex-grow-1 d-flex align-items-center">
          <div 
            :class="'text-truncate query_word ' + (word.ignored ? 'text-decoration-line-through ' : '')  + (!word.on_page ? 'text-muted' : '')" 
            :style="{maxWidth:'calc(100% - 24px)'}" 
            translate="no"
          >{{ word.word }}</div>
          <b-icon-arrow-clockwise animation="spin" v-if="loading == word.word" />
          <div v-else-if="!isDemo" class="ml-1 small cursor-pointer" variant="light" @click="toggleIgnore(word)">
            <b-icon-dash-circle v-if="!word.ignored" v-b-tooltip.hover="'Mute'" />
            <b-icon-plus-circle v-else v-b-tooltip.hover="'Unmute'" />
          </div>
        </div>
        <div class="mr-2 word-list-item-progress">
          <b-progress :value="word.score" :max="100" v-if="!word.ignored" :variant="variant(word)" height=".4rem" :animated="!!loading"  />
        </div>
      </div>
      <!-- <div class="word-list-item mb-1">
        <b-link v-if="hideForm" @click="hideForm = false" class="text-small">
          Add a Keyword <b-icon-plus-circle class="text-primary" />
        </b-link>
        <b-form inline v-else @submit.prevent="addWord()" class="d-flex">
          <b-form-input size="sm" v-model="newWord" placeholder="Add a Keyword" class="flex-grow-1" :disabled="loading" />
          <b-button type="submit" size="sm" variant="primary" :disabled="!newWord || loading">Add</b-button>
        </b-form>
      </div> -->
    </b-skeleton-wrapper>
  </div>
</template>
<style lang="scss">
.word-list-item {
  border-bottom: 1px solid #eee;
  .cursor-pointer {
    color: #ddd;
    .item:hover & {
      color: #333
    }
  }
}
.word-list-item-progress {
  width: 70px;
}
</style>
<script>
import {get, orderBy} from 'lodash'
import QUERY_WORD_MUTATION from '@/graphql/QueryWordMutation.gql'
import DELETE_QUERY_WORD from '@/graphql/DeleteQueryWord.gql'
import { BIconInfoCircle, BIconDashCircle, BIconPlusCircle, BIconArrowClockwise } from 'bootstrap-vue'
export default {
  name: 'PageWords',
  props: ['page', 'query_words', 'isDemo'],
  components: {BIconInfoCircle, BIconDashCircle, BIconPlusCircle, BIconArrowClockwise},
  data: () => {
    return {
      loading: false,
      tooltip: '...',
      paginateNumber: 1,
      limit: 5,
      hideForm: true,
      newWord: '',
      fields: [
        {
          key: 'score',
          label: 'Priority',
        },
        {
          key: 'word',
          label: 'Keyword',
        },
        {
          key: 'title_index',
          label: 'In Title',
        },
        {
          key: 'ignored',
          label: 'Ignore',
        },
      ],
    }
  },

  computed: {
    filteredWords() {
      return orderBy((this.query_words || [])
        .filter(e => e.score > 0)
        .slice(0, 10), 'score', 'desc')
    }
  },

  watch: {
    page() {
      this.loading = false
    }
  },
  methods: {
    variant(word) {
      if(word.score < process.env.VUE_APP_WORD_CLICK_THRESHOLD) {
        return 'secondary'
      }
      if('title_index' in word) {
         return word.title_index >= 0 ? 'success' : 'danger'
      }
      return 'dark'
    },
    async toggleIgnore(item) {
      this.loading = item.word
      if(item.id && !item.ignored) {
        await this.$apollo.mutate({
          mutation: DELETE_QUERY_WORD,
          variables: {id: item.id}
        })
      } else {
        await this.$apollo.mutate({
          mutation: QUERY_WORD_MUTATION,
          variables: {
            page_id: this.page.id,
            word: item.word,
            stem: item.stem || item.word.toLowerCase(),
            ignored: !item.ignored
          }
        })
      }
      const action = item.ignored ? 'Unmuted' : 'Muted'
      _zyppy.track(`Word ${action}`, {
        page_id: this.page.id,
        word: item.word,
        stem: item.stem,
      })
      this.$emit('refresh')
    },
    async addWord() {
      this.loading = true
      const item = {
        page_id: this.page.id,
        word: this.newWord,
        stem: this.newWord.toLowerCase(),
      }
      await this.$apollo.mutate({
        mutation: QUERY_WORD_MUTATION,
        variables: {
          ...item,
          ignored: false,
        }
      })
      _zyppy.track(`Word Added`, item)
      this.newWord = ''
      this.hideForm = true
      this.$emit('refresh')
    },
  }
}
</script>
